import StockCategoriesPage from "../../../features/admin/stock-categories/stock-categories-page";

export default function StockCategories() {
  return <StockCategoriesPage />;
}
